
import { Box, Typography, Paper, Card, CardContent, Button } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { banking } from "../../assets";
import { baseURL } from "../../services/constants";

const CategoryOverview = ({ categoryData, onApiClick }) => {
  if (!categoryData) return null;

  return (
    <Box sx={{ px: { xs: 2, md: 4, lg: 6 }, py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h3"
          color="#020817"
          sx={{ fontSize: "28px", fontWeight: "700" }}
        >
          {categoryData.categoryName}
        </Typography>
        {categoryData.categoryDescription && (
          <Typography variant="body2" sx={{ fontSize: "16px", mt: 1 }}>
            {categoryData.categoryDescription}
          </Typography>
        )}
      </Box>

      <Box
        component="img"
        src={
          categoryData?.image?.data?.attributes?.url
            ? `${baseURL.replace(/\/api$/, "")}${categoryData.image.data.attributes.url}`
            : banking
        }
        alt={categoryData.categoryName}
        sx={{
          width: "100%",
          height: "auto",
          borderRadius: 2,
          mb: 4,
        }}
        onError={(e) => {
          e.target.src = banking;
        }}
      />

      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          color="#000000"
          sx={{ fontSize: "24px", fontWeight: "600" }}
        >
          Introduction
        </Typography>
        <Typography
          variant="body2"
          color="#000000"
          sx={{ fontSize: "16px", mt: 1, fontWeight: "400" }}
        >
          {categoryData.categoryDescription ||
            "Comprehensive API solutions for your integration needs."}
        </Typography>
      </Box>

      <Paper
        elevation={0}
        sx={{
          backgroundColor: "#E8F4FF",
          px: 3,
          py: 2,
          borderRadius: 2,
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          mb: 4,
        }}
      >
        <Box>
          <Typography
            variant="subtitle1"
            fontWeight="500"
            sx={{ color: "#1E88E5", mb: 1, fontSize: "18px" }}
          >
            <InfoOutlinedIcon color="primary" sx={{ mt: "2px" }} /> Category
            Details
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontSize: "16px", fontWeight: "400", color: "#000000" }}
          >
            This category provides comprehensive solutions with multiple API
            endpoints to meet your integration requirements. Each API is
            designed for specific use cases and can be integrated seamlessly
            into your applications.
          </Typography>
        </Box>
      </Paper>

      {/* Common Use Cases */}
      {categoryData.commonUseCase && categoryData.commonUseCase.length > 0 && (
        <Box sx={{ mb: 4 }}>
          {categoryData.commonUseCase.map((useCase, index) => (
            <Box key={index} sx={{ mb: 3 }}>
              <Typography
                variant="h6"
                gutterBottom
                color="#000000"
                sx={{ fontSize: "24px", fontWeight: "500" }}
              >
                {useCase.title}
              </Typography>

              <Paper
                elevation={0}
                sx={{
                  border: "1px solid #E0E0E0",
                  borderRadius: 2,
                  px: 3,
                  py: 2.5,
                  backgroundColor: "#fff",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "18px",
                    color: "#000000",
                    whiteSpace: "pre-line",
                    lineHeight: "2.5",
                  }}
                >
                  {useCase.description}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Box>
      )}

      <Box sx={{ mb: 4 }}>
        <Typography
          sx={{ fontSize: "18px", fontWeight: 600, color: "#000", mb: 2 }}
        ></Typography>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #E0E0E0",
            borderRadius: 2,
            px: 3,
            py: 2.5,
            backgroundColor: "#fff",
          }}
        >
          <Typography
            sx={{ fontSize: "16px", fontWeight: 600, color: "#000", mb: 1.5 }}
          >
            Best Practices
          </Typography>

          <Box component="ul" sx={{ pl: 3 }}>
            {[
              "All APIs support RESTful integration with JSON payloads and are stateless",
              "Secure endpoints use token-based authentication with API key and secret",
              "Standard HTTP status codes are used for success and error responses",
              "Implement appropriate error handling for robust integration",
              "Rate limiting applies based on your account's credit allocation",
            ].map((item, idx) => (
              <Box
                key={idx}
                component="li"
                sx={{
                  fontSize: "16px",
                  color: "#000",
                  mb: 1.5,
                  lineHeight: 1.6,
                }}
              >
                {item}
              </Box>
            ))}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default CategoryOverview;